const Schema = Object.freeze({

    CIDADE: "LocalCity",
    ESTADO: "LocalState",
    PAIS: "LocalCountry",

    ITEM: "Item",
    ITEM_GRUPO: "ItemGrupo",
    ITEM_UNIDADE: "ItemUnidade",
    ITEM_CLASSIFICACAO: "ItemClassificacao",

    SALDO_DE_ESTOQUE: "StockBalance",
    OPERACAO_DE_ESTOQUE: "StockOperation",
    OPERACAO_DE_ESTOQUE_MOVIMENTO: "StockMov",

    COLABORADOR: "Collaborator",

    CLIENTE: "Cliente",
    CLIENTE_CONTATOS: "ClienteContatos",
    CLIENTE_SEGMENTOS_DE_MERCADO: "ClienteSegmentoDeMercado",

    FORNECEDOR: "Fornecedor",
    FORNECEDOR_CONTATOS: "FornecedorContatos",
    FORNECEDOR_MATERIAIS: "FornecedorMateriais",
    FORNECEDOR_MATERIAIS_FORNECIDOS: "FornecedorMateriaisFornecidos",

    SOLICITACAO_DE_ORCAMENTO: "SalesOrder",

    JOB: "Project",
    JOB_ITENS: "ProjectItens",
    JOB_SUBITEMS: "ProjectItensDeItens",
    JOB_ADITIVOS: "ProjectAditivos",
    JOB_PARCELAS: "Parcelas",

    REVISAO_JOB: "RevisaoDeJob",
    REVISAO_JOB_ITENS: "RevisaoDeJobItens",
    REVISAO_JOB_SUBITEMS: "RevisaoDeJobItensDeItens",
    REVISAO_JOB_ADITIVOS: "RevisaoDeJobAditivos",

    ORDEM_DE_SERVICO: "OrdemDeServico",
    ORDEM_DE_SERVICO_ITENS: "OrdemDeServicoItens",
    ORDEM_DE_SERVICO_ITEM_UNIDADE: "OrdemDeServicoItemUnidade",

    HISTORICO_ORDEM_DE_SERVICO_ITEM: "HistoricoOrdemDeServicoItens",

    REQUISICAO_DE_COMPRA: "RequisicaoDeCompra",

    COTACAO_DE_PEDIDO_DE_COMPRA: "CotacaoDePedidoDeCompra",
    COTACAO_DE_PEDIDO_DE_COMPRA_ITENS: "CotacaoDePedidoDeCompraItens",

    PEDIDO_DE_COMPRA: "PedidoDeCompra",
    PEDIDO_DE_COMPRA_ITENS: "PedidoDeCompraItens",
    PEDIDO_DE_COMPRA_PARCELAS: "PedidoDeCompraParcelas",
    PEDIDO_DE_COMPRA_APROVADORES: "PedidoDeCompraAprovadores",
    PEDIDO_DE_COMPRA_FOLLOWUPS: "PedidoDeCompraFollowUps",

    REVISAO_PEDIDO_DE_COMPRA: "RevisaoDePedidoDeCompra",
    REVISAO_PEDIDO_DE_COMPRA_ITENS: "RevisaoDePedidoDeCompraItens",
    REVISAO_PEDIDO_DE_COMPRA_PARCELAS: "RevisaoDePedidoDeCompraParcelas",
    REVISAO_PEDIDO_DE_COMPRA_APROVADORES: "RevisaoDePedidoDeCompraAprovadores",
    REVISAO_PEDIDO_DE_COMPRA_FOLLOWUPS: "RevisaoDePedidoDeCompraFollowUps",

    NOTA_FISCAL_RECEBIDA: "FisDocRec",

    CONTAS_A_PAGAR: "FinPay",
    CONTAS_A_PAGAR_PAGAMENTOS: "FinPayPagamentos",

    PAGAMENTO_ELETRONICO_DE_FOLHA_DE_PAGAMENTO: "FolhaDePagamento",
    PAGAMENTO_ELETRONICO_DE_FERIAS: "PagamentosFerias",
    PAGAMENTO_ELETRONICO_DE_RESCISOES: "PagamentosRescisoes",
    PAGAMENTO_ELETRONICO_DE_PENSOES_ALIMENTICIAS: "PagamentosPensoesAlimenticias",

    LISTA_DE_EMBARQUE: "PackingListEmb",
    LISTA_DE_EMBARQUE_ITEM: "PackingListEmbItem",

    NOTA_FISCAL_EMITIDA: "FisDocEmi",
    NOTA_FISCAL_EMITIDA_PARCELAS: "FisDocEmiFin",

    CONTAS_A_RECEBER: "FinRec",
    CONTAS_A_RECEBER_RECEBIMENTOS: "FinRecRecebimentos",
    CONTAS_A_RECEBER_RECEBIMENTOS_VINCULOS: "FinRecRecebimentosVinculos",

    MOVIMENTO_FINANCEIRO: "FinMov",

    CONTAS_FINANCEIRAS: "FinAccount",

})

export default Schema;